export default "__VITE_ASSET__c0c30399__"